import React, { useState, useEffect } from 'react';
import {
	Button,
	Typography,
	Col,
	Row,
	Input,
	Modal,
	Form,
	Select,
	Spin,
	notification,
	Tooltip
} from 'antd';
import env from '../../../../../../environment';
import authClient from '../../../../../../Auth/Auth';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { InputDate } from 'afrodita';
import { renderComponent } from '../../data/renderComponent';
import moment from 'moment';

const { Text } = Typography;
const { Option } = Select;

const TableAbanca = ({ mortgageId, mortgage }) => {
	const [form] = Form.useForm();
	const navigate = useNavigate();
	const [visibleCancel, setVisibleCancel] = useState(false);
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const bankRequestId = location?.state !== undefined ? location.state.bankRequestId : undefined;
	const [emptyFields, setEmptyFields] = useState([]);
	const [selectValues, setSelectValues] = useState(undefined);
	const [countries, setCountries] = useState<any>([]);
	const [abancaRates, setAbancaRates] = useState<any>([]);
	const [rateList, setRateList] = useState<any>([]);

	const labelStyles = {
		fontSize: 10,
		color: '#2F4858',
		fontWeight: 400
	};

	useEffect(() => {
		getSelectValues();
		getCountries();
		getAbancaRates();
		const initialValues = generateInitialValues();
		form.setFieldsValue(initialValues);
	}, []);

	useEffect(() => {
		if (mortgage && selectValues && abancaRates) {
			handleFormChange();
		}
	}, [form, mortgage, selectValues, abancaRates]);

	const getCountries = () => {
		axios.get(`${env.api.url}/v1/countries`).then((response) => {
			setCountries(response.data.data);
		});
	};

	const getAbancaRates = () => {
		axios
			.get(`${env.api.url}/banks/abanca/get-abanca-rates/${mortgageId}/${bankRequestId}`, {
				headers: { Authorization: `Bearer ${authClient.getToken()}` }
			})
			.then((response) => {
				if (response.data.success) {
					setAbancaRates(response.data.data);
				} else {
					notification.error({
						message: 'Error',
						description: 'Parece que ha ocurrido un error'
					});
					navigate(`/operations/mortgages/${mortgageId}/form-send-bank`);
				}
			})
			.catch((err) => {
				console.log('Error: ', err);
				notification.error({
					message: 'Error',
					description: 'Parece que ha ocurrido un error'
				});
				navigate(`/operations/mortgages/${mortgageId}/form-send-bank`);
			});
	};

	const getSelectValues = () => {
		axios
			.get(`${env.api.url}/banks/abanca/data/json`, {
				headers: { Authorization: `Bearer ${authClient.getToken()}` }
			})
			.then((response) => {
				setSelectValues(response.data.data);
			});
	};

	const handleFormChange = () => {
		const values = form.getFieldsValue();
		const undefinedFields = Object.entries(values)
			.filter(
				([fieldName, value]) => value === undefined || value === '' || value === 'Fecha inválida'
			)
			.map(([fieldName]) => fieldName);
		setEmptyFields(undefinedFields);
	};

	const renderFields = (prefix) => (
		<Row gutter={[32, 0]} style={{ marginTop: 24 }}>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.idDocumentType`}
					label={<Text style={labelStyles}>{'Tipo de documento de identidad'}</Text>}
					className={emptyFields.includes(`${prefix}.idDocumentType`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Select
						onChange={handleFormChange}
						placeholder="Seleccionar"
						options={[
							{ value: 'ID', label: 'DNI' },
							{ value: 'FOREIGN_ID', label: 'NIE' },
							{ value: 'OTHER', label: 'Otro' }
						]}
					/>
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.personType`}
					label={<Text style={labelStyles}>{'Tipo de persona'}</Text>}
					className={emptyFields.includes(`${prefix}.personType`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Select
						onChange={handleFormChange}
						placeholder="Seleccionar"
						options={selectValues?.personType.map((p: any) => ({ value: p.code, label: p.name }))}
					/>
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.nif`}
					label={<Text style={labelStyles}>{'Número del documento de identidad'}</Text>}
					className={emptyFields.includes(`${prefix}.nif`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Input />
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.name`}
					label={<Text style={labelStyles}>{'Nombre'}</Text>}
					className={emptyFields.includes(`${prefix}.name`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Input />
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.firstSurname`}
					label={<Text style={labelStyles}>{'Primer apellido'}</Text>}
					className={emptyFields.includes(`${prefix}.firstSurname`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Input />
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.lastSurname`}
					label={<Text style={labelStyles}>{'Segundo apellido'}</Text>}
					className={emptyFields.includes(`${prefix}.lastSurname`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Input />
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.birthdate`}
					label={<Text style={labelStyles}>{'Fecha de nacimiento'}</Text>}
					className={emptyFields.includes(`${prefix}.birthdate`) ? 'shadowed' : ''}
					rules={[
						{ required: true, message: 'Por favor, rellene este campo' },
						{
							validator: async (_, value) => {
								if (!value) {
									return Promise.resolve();
								}
								const formattedDate = moment(value, 'DD-MM-YYYY', true);
								if (!formattedDate.isValid() || formattedDate.format('DD-MM-YYYY') !== value) {
									return Promise.reject('Introduce una fecha válida');
								}

								return Promise.resolve();
							}
						}
					]}>
					<InputDate
						onChange={handleFormChange}
						type="date"
						style={{
							width: '100%',
							height: '40px',
							borderRadius: '4px',
							borderColor: '#C0DAEE'
						}}></InputDate>
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.nationality`}
					label={<Text style={labelStyles}>{'Nacionalidad'}</Text>}
					className={emptyFields.includes(`${prefix}.nationality`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Select
						onChange={handleFormChange}
						showSearch
						style={{ width: '100%' }}
						placeholder="Seleccionar"
						filterOption={(input, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
							option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						options={countries?.countries?.map((p: any) => ({
							value: p.code,
							label: p.name_es
						}))}></Select>
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.cityzenship`}
					label={<Text style={labelStyles}>{'País de residencia'}</Text>}
					className={emptyFields.includes(`${prefix}.cityzenship`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Select
						onChange={handleFormChange}
						showSearch
						style={{ width: '100%' }}
						placeholder="Seleccionar"
						filterOption={(input, option: any) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
							option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
						options={countries?.countries?.map((p: any) => ({
							value: p.code,
							label: p.name_es
						}))}></Select>
				</Form.Item>
			</Col>
			<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
				<Form.Item
					name={`${prefix}.maritalStatus`}
					label={<Text style={labelStyles}>{'Estado civil'}</Text>}
					className={emptyFields.includes(`${prefix}.maritalStatus`) ? 'shadowed' : ''}
					rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
					<Select placeholder="Seleccionar" onChange={handleFormChange}>
						{renderComponent('maritalStatus').options.map((maritalStatus) => (
							<Option key={maritalStatus.value} value={maritalStatus.value}>
								{maritalStatus.label}
							</Option>
						))}
					</Select>
				</Form.Item>
			</Col>
			{prefix !== 'owner1' && (
				<>
					<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
						<Form.Item
							name={`${prefix}.householdUnit`}
							label={<Text style={labelStyles}>{'¿Pertenece a la unidad familiar del T1?'}</Text>}
							className={emptyFields.includes(`${prefix}.householdUnit`) ? 'shadowed' : ''}
							rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
							<Select
								onChange={handleFormChange}
								placeholder="Seleccionar"
								options={selectValues?.householdUnit.map((p: any) => ({
									value: p.code,
									label: p.name
								}))}
							/>
						</Form.Item>
					</Col>
					<Col xs={12} md={8} sm={8} lg={8} xl={6} xxl={6}>
						<Form.Item
							name={`${prefix}.mainApplicantRelation`}
							label={<Text style={labelStyles}>{'Relación con el T1'}</Text>}
							className={emptyFields.includes(`${prefix}.mainApplicantRelation`) ? 'shadowed' : ''}
							rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
							<Select
								onChange={handleFormChange}
								placeholder="Seleccionar"
								options={selectValues?.mainApplicantRelation.map((p: any) => ({
									value: p.code,
									label: p.name
								}))}
							/>
						</Form.Item>
					</Col>
				</>
			)}
		</Row>
	);

	const renderOwnersForm = () => {
		const owners = mortgage.operation.owners || 1;
		const arrayForm = [];

		for (let i = 1; i <= owners; i++) {
			arrayForm.push(
				<React.Fragment key={`owner-${i}`}>
					<Row>
						<Text
							style={{
								fontSize: 14,
								fontWeight: 600,
								color: '#2F4858',
								marginTop: i === 1 ? 32 : 24
							}}>
							{`Titular ${i}`}
						</Text>
					</Row>
					{renderFields(`owner${i}`)}
				</React.Fragment>
			);
		}

		return arrayForm;
	};

	const generateInitialValues = () => {
		const owners = mortgage.operation.owners || 1;
		const initialValues = {};

		for (let i = 1; i <= owners; i++) {
			initialValues[`owner${i}.idDocumentType`] =
				mortgage[`owner${i}`]?.idDocumentType || undefined;
			initialValues[`owner${i}.nif`] = mortgage[`owner${i}`]?.nif || undefined;
			initialValues[`owner${i}.name`] = mortgage[`owner${i}`]?.name || undefined;
			initialValues[`owner${i}.firstSurname`] = mortgage[`owner${i}`]?.firstSurname || undefined;
			initialValues[`owner${i}.lastSurname`] = mortgage[`owner${i}`]?.lastSurname || undefined;
			initialValues[`owner${i}.lastSurname`] = mortgage[`owner${i}`]?.lastSurname || undefined;
			(initialValues[`owner${i}.birthdate`] =
				mortgage[`owner${i}`]?.birthdate !== 'Fecha inválida'
					? moment(mortgage[`owner${i}`]?.birthdate, 'YYYY-MM-DD').format('DD-MM-YYYY')
					: undefined),
				(initialValues[`owner${i}.nationality`] = mortgage[`owner${i}`]?.nationality || undefined);
			initialValues[`owner${i}.cityzenship`] = mortgage[`owner${i}`]?.cityzenship || undefined;
			initialValues[`owner${i}.maritalStatus`] = mortgage[`owner${i}`]?.maritalStatus || undefined;
		}

		return initialValues;
	};

	const createParticipant = (index, values) => {
		const participant: any = {
			idDocumentType: values[`owner${index}.idDocumentType`],
			personType: values[`owner${index}.personType`],
			nif: values[`owner${index}.nif`],
			name: values[`owner${index}.name`],
			firstSurname: values[`owner${index}.firstSurname`],
			lastSurname: values[`owner${index}.lastSurname`],
			birthdate: moment(values[`owner${index}.birthdate`], 'DD-MM-YYYY').format('YYYY-MM-DD'),
			nationality: values[`owner${index}.nationality`],
			cityzenship: values[`owner${index}.cityzenship`],
			maritalStatus: values[`owner${index}.maritalStatus`]
		};

		if (index > 1) {
			participant.mainApplicantRelation = values[`owner${index}.mainApplicantRelation`];
			participant.householdUnit = values[`owner${index}.householdUnit`];
		}

		return participant;
	};

	const onFinish = (values: any) => {
		setLoading(true);
		const obj = {
			bankRequestId: bankRequestId,
			operationId: mortgageId,
			participants: [],
			rate: rateList.find((r: any) => r.id === values.rate)
		};

		delete obj.rate.id;

		const owners = mortgage.operation.owners;
		for (let i = 1; i <= owners; i++) {
			const ownerData = createParticipant(i, values);
			obj.participants.push(ownerData);
		}

		axios
			.post(
				`${env.api.url}/banks/abanca/create-abanca-operation`,
				{ ...obj },
				{ headers: { Authorization: `Bearer ${authClient.getToken()}` } }
			)
			.then((response) => {
				if (response.data.success) {
					setLoading(false);
					notification.success({
						message: 'Se ha generado correctamente el bank Resquest.',
						description: 'El bank Resquest se generó correctamente'
					});
					navigate(`/operations/mortgages/${mortgageId}/?tab=5`);
					window.location.reload();
				} else {
					setLoading(false);
					notification.error({
						message: 'Error',
						description: response.data.message
					});
				}
			})
			.catch((error) => {
				console.error('Error:', error);
				setLoading(false);
				notification.error({
					message: 'Error',
					description: 'Parece que ha ocurrido un error'
				});
			});
	};

	const handleCancel = () => {
		setVisibleCancel(!visibleCancel);
	};

	const handleOk = () => {
		setVisibleCancel(!visibleCancel);
		navigate(`/operations/mortgages/${mortgageId}/form-send-bank`);
	};

	if (loading) {
		return (
			<>
				<div
					style={{
						height: '70vh',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexDirection: 'column'
					}}>
					<Spin size="large" />
					<div style={{ marginTop: 20 }}>
						<Text style={{ fontSize: 14, fontWeight: 500 }}>
							Por favor, no cierre ni recargue la pagina, puede tardar hasta 3 minutos...
						</Text>
					</div>
				</div>
			</>
		);
	}

	if (!loading && selectValues && mortgage && abancaRates.length > 0) {
		return (
			<>
				<Form
					key={'bankinterForm'}
					form={form}
					layout="vertical"
					name="sendMessageForm"
					className="gb-form-offers-new"
					style={{ width: '100%' }}
					onChange={handleFormChange}
					onFinish={onFinish}>
					<Text style={{ fontSize: 14, fontWeight: 600, color: '#2F4858', marginTop: 24 }}>
						Datos de la oferta solicitada
					</Text>
					<Row gutter={32} style={{ marginTop: 24 }}>
						<Col xs={8} md={8} sm={8} lg={8} xl={8} xxl={8}>
							<Form.Item
								name="rateType"
								label={<Text style={labelStyles}>{'Tarifa'}</Text>}
								className={emptyFields.includes('rateType') ? 'shadowed' : ''}
								rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
								<Select
									placeholder="Seleccionar"
									onChange={(value) => {
										handleFormChange();
										form.resetFields(['rate']);
										setRateList(abancaRates?.find((r: any) => r.id === value)?.tarifasHipotecarias);
									}}>
									{abancaRates?.map((rate: any) => (
										<Option key={rate.id} value={rate.id}>
											{rate.nombre}
										</Option>
									))}
								</Select>
							</Form.Item>
						</Col>
						{rateList.length > 0 && (
							<Col xs={16} md={16} sm={16} lg={16} xl={16} xxl={16}>
								<Form.Item
									name="rate"
									label={<Text style={labelStyles}>{'Tarifas hipotecarias'}</Text>}
									className={emptyFields.includes('rate') ? 'shadowed' : ''}
									rules={[{ required: true, message: 'Por favor, rellene este campo' }]}>
									<Select placeholder="Seleccionar" onChange={handleFormChange}>
										{rateList?.map((item: any) => (
											<Option key={item.id} value={item.id}>
												<Tooltip
													title={`${item.nombre} - Plazo: ${item.plazo / 12} años`}
													overlayStyle={{
														wordWrap: 'break-word',
														whiteSpace: 'normal',
														maxWidth: 'none'
													}}>
													{item.nombre} - Plazo: {item.plazo / 12} años
												</Tooltip>
											</Option>
										))}
									</Select>
								</Form.Item>
							</Col>
						)}
					</Row>
					{renderOwnersForm()}
					<Row style={{ justifyContent: 'center', marginTop: 20 }}>
						<Button
							style={{ height: 32, width: 96, fontSize: 14 }}
							className="button-secundary-gibobs"
							onClick={handleCancel}
							type="dashed">
							Atras
						</Button>
						<Button
							style={{ height: 32, marginLeft: 8, width: 96, fontSize: 14 }}
							type="primary"
							htmlType="submit"
							className="button-primari-gibobs">
							Aceptar
						</Button>
					</Row>
				</Form>
				<Modal
					className="gb-modal-style-common"
					cancelButtonProps={{ className: 'button-secundary-gibobs', style: { width: 96 } }}
					okButtonProps={{ className: 'button-primari-gibobs', style: { width: 96 } }}
					open={visibleCancel}
					title={
						<Text style={{ fontSize: '14px', fontWeight: '600px', color: '#2F4858' }}>
							{'Cancelar envío'}
						</Text>
					}
					okText={'Aceptar'}
					cancelText={'Cancelar'}
					width={404}
					onCancel={handleCancel}
					onOk={handleOk}>
					<Text style={{ fontSize: '12px', fontWeight: '400px', color: '#2F4858' }}>
						{'¿Aceptas la cancelación del envío a Abanca?'}
					</Text>
				</Modal>
			</>
		);
	} else {
		return (
			<div
				style={{
					height: '80vh',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center'
				}}>
				<Spin size="large" />
			</div>
		);
	}
};
export default TableAbanca;
